import { format } from 'date-fns';
import {useTranslation} from "react-i18next";
import { Link } from 'react-router-dom';

import './Circulation.css';

const Circulation = ({ data }) => {
  const {t} = useTranslation();

  return (
    <div className="circulation-container w-100 bg-white p-4 br-2">
      <p className="">{data?.productName}</p>
      <div className="circulation-container__caption">
        <div className="circulation-container__informations">
          <div className="circulation-container__information">
            <span>{t("CIRCULATION_NUMBER")}</span>
            <span>{data?.code}</span>
          </div>
          <div className="circulation-container__information">
            <span>{t("POOL_AMOUNT")}</span>
            <span
              className={
                !data?.possibleSeeTotalAmount
                  ? 'circulation-container__information-blur'
                  : ''
              }
            >
              {data?.totalAmount} AZN
            </span>
          </div>
          <div className="circulation-container__information">
            <span>{t("BET_STOP_DATE")}</span>
            <span className="circulation-container__information-black">
              {data?.expiredDate &&
                format(new Date(data.expiredDate), 'dd-MM-yyyy HH:mm')}
            </span>
          </div>
          <div className="circulation-container__information">
            <span>{t("CIRCULATION_STOP_DATE")}</span>
            <span className="circulation-container__information-black">
              {data?.resultedDate &&
                format(new Date(data.resultedDate), 'dd-MM-yyyy HH:mm')}
            </span>
          </div>
          <div className="circulation-container__information">
            <span>{t("CIRCULATION_STATUS")}</span>
            <span
              style={{
                color: data?.canBePlayed ? '#24A3FF' : 'red',
              }}
            >
              {data?.canBePlayed ? t("ACTIVE") : t("FINISHED")}
            </span>
          </div>
        </div>
        <div className="circulation-container__buttons">
          <Link to={`/circulations/${data?.id}/tickets`}>{t("TICKETS")}</Link>
        </div>
      </div>
    </div>
  );
};

export default Circulation;
